// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InvoicingRulesModal.modalContainer {
  background: white;
  width: 684px;
  min-height: 684px;
  padding: 48px;
  align-self: center;
}

.InvoicingRulesModal .modalHeading {
    font-size: 24px;
    color: #0f1113;
    font-weight: 400;
  }

.InvoicingRulesModal .flex {
    display: flex;
  }

.InvoicingRulesModal .flex-1 {
    flex: 1 1 0%;
  }

.InvoicingRulesModal .height-24 {
    height: 24px;
  }

.InvoicingRulesModal .height-32 {
    height: 32px;
  }

.InvoicingRulesModal .width-16 {
    width: 16px;
  }

.InvoicingRulesModal .font-bold {
    font-weight: 700;
  }

.InvoicingRulesModal .overflow-y-scroll {
    overflow-y: scroll;
  }

.InvoicingRulesModal .gridContainer {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

.InvoicingRulesModal .infoContainer {
    border: 2px solid #efeff0;
    padding: 8px 16px;
  }

.InvoicingRulesModal .infoLabel {
    font-size: 12px;
  }

.InvoicingRulesModal .infoValue {
    font-size: 14px;
    color: #2a2d30;
  }

.InvoicingRulesModal .inputContainer {
    border: 2px solid black;
    padding: 8px 16px;
  }

.InvoicingRulesModal .accessorialHeading {
    font-weight: 400;
    font-size: 14px;
  }

.InvoicingRulesModal .accessorialGridContainer {
    height: 200px;
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

.InvoicingRulesModal .checkboxWithLabelContainer {
    display: flex;
    align-items: center;
  }

.InvoicingRulesModal .buttonRowContainer {
    display: flex;
    justify-content: flex-end;
  }
`, "",{"version":3,"sources":["webpack://./app/components/DepartmentDetailSidebar/components/DepartmentDetailSidebarInvoicingRules/components/InvoicingRulesModal/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAGE;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;AAEA;IACE,aAAa;EACf;;AAEA;IACE,YAAY;EACd;;AAEA;IACE,YAAY;EACd;;AAEA;IACE,YAAY;EACd;;AAEA;IACE,WAAW;EACb;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,kBAAkB;EACpB;;AAEA;IACE,aAAa;IACb,SAAS;IACT,gDAAgD;EAClD;;AAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,eAAe;IACf,cAAc;EAChB;;AAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;AAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;AAEA;IACE,aAAa;IACb,aAAa;IACb,SAAS;IACT,gDAAgD;EAClD;;AAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;AAEA;IACE,aAAa;IACb,yBAAyB;EAC3B","sourcesContent":[".InvoicingRulesModal.modalContainer {\n  background: white;\n  width: 684px;\n  min-height: 684px;\n  padding: 48px;\n  align-self: center;\n}\n\n.InvoicingRulesModal {\n  .modalHeading {\n    font-size: 24px;\n    color: #0f1113;\n    font-weight: 400;\n  }\n\n  .flex {\n    display: flex;\n  }\n\n  .flex-1 {\n    flex: 1 1 0%;\n  }\n\n  .height-24 {\n    height: 24px;\n  }\n\n  .height-32 {\n    height: 32px;\n  }\n\n  .width-16 {\n    width: 16px;\n  }\n\n  .font-bold {\n    font-weight: 700;\n  }\n\n  .overflow-y-scroll {\n    overflow-y: scroll;\n  }\n\n  .gridContainer {\n    display: grid;\n    gap: 20px;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .infoContainer {\n    border: 2px solid #efeff0;\n    padding: 8px 16px;\n  }\n\n  .infoLabel {\n    font-size: 12px;\n  }\n\n  .infoValue {\n    font-size: 14px;\n    color: #2a2d30;\n  }\n\n  .inputContainer {\n    border: 2px solid black;\n    padding: 8px 16px;\n  }\n\n  .accessorialHeading {\n    font-weight: 400;\n    font-size: 14px;\n  }\n\n  .accessorialGridContainer {\n    height: 200px;\n    display: grid;\n    gap: 20px;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .checkboxWithLabelContainer {\n    display: flex;\n    align-items: center;\n  }\n\n  .buttonRowContainer {\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
